import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "bind-activity-item-navs-widget" }
const _hoisted_2 = { class: "bind-activity-item-navs-dialog" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "bind-activity-item-navs-dialog__title" }, "选择导航（可多选）", -1)
const _hoisted_4 = { class: "bind-activity-item-navs-dialog__panel" }
const _hoisted_5 = { class: "bind-activity-item-navs-node" }
const _hoisted_6 = {
  key: 0,
  class: "bind-activity-item-navs-node__count"
}
const _hoisted_7 = {
  key: 1,
  class: "bind-activity-item-navs-dialog__empty"
}

import { computed, ref } from 'vue';
import { OioButton, OioModal } from '@kunlun/vue-ui-antd';

interface ActivityNavRelRecord {
  id?: number | string;
  sideNavId?: number | string;
  sideNavCode?: string;
  sideNavName?: string;
  sideNavSort?: number;
  horizontalNavId?: number | string;
  horizontalNavCode?: string;
  horizontalNavName?: string;
  horizontalNavSort?: number;
}

interface TreeNode {
  key: string;
  title: string;
  code: string;
  count?: number;
  raw?: ActivityNavRelRecord;
  children?: TreeNode[];
}

interface Props {
  label: string;
  disabled: boolean;
  getCurrentPageNavConfigs: () => ActivityNavRelRecord[];
  applyNavsToSelectedRows: (navConfigs: ActivityNavRelRecord[]) => void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BindActivityItemNavs',
  props: {
    label: null,
    disabled: { type: Boolean },
    getCurrentPageNavConfigs: null,
    applyNavsToSelectedRows: null
  },
  setup(__props: any) {

const props = __props as {
  label: string;
  disabled: boolean;
  getCurrentPageNavConfigs: () => ActivityNavRelRecord[];
  applyNavsToSelectedRows: (navConfigs: ActivityNavRelRecord[]) => void;
}



const visible = ref(false);
const confirmLoading = ref(false);
const checkedKeys = ref<string[]>([]);
const treeData = ref<TreeNode[]>([]);
const navConfigMap = ref<Record<string, ActivityNavRelRecord>>({});

const handleCheck = (keys: string[] | { checked: string[] }) => {
  checkedKeys.value = Array.isArray(keys) ? keys : keys.checked;
};

const closeModal = () => {
  visible.value = false;
};

const buildTreeData = (records: ActivityNavRelRecord[]) => {
  const sideNavMap = new Map<string, TreeNode>();

  records.forEach((item) => {
    if (!item.sideNavCode) {
      return;
    }
    if (!sideNavMap.has(item.sideNavCode)) {
      sideNavMap.set(item.sideNavCode, {
        key: item.sideNavCode,
        title: item.sideNavName || '',
        code: item.sideNavCode,
        raw: item
      });
    }
    navConfigMap.value[item.sideNavCode] = item;
  });

  return Array.from(sideNavMap.values())
    .sort((a, b) => a.code.localeCompare(b.code));
};

const openModal = () => {
  checkedKeys.value = [];
  navConfigMap.value = {};
  treeData.value = buildTreeData(props.getCurrentPageNavConfigs() || []);
  visible.value = true;
};

const submitSelection = async () => {
  confirmLoading.value = true;
  try {
    const selectedNavConfigs = checkedKeys.value
      .map((key) => navConfigMap.value[key])
      .filter(Boolean);
    props.applyNavsToSelectedRows(selectedNavConfigs);
    closeModal();
  } finally {
    confirmLoading.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_tree = _resolveComponent("a-tree")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(OioButton), {
      type: "primary",
      size: "small",
      disabled: __props.disabled,
      onClick: openModal
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(__props.label), 1)
      ]),
      _: 1
    }, 8, ["disabled"]),
    _createVNode(_unref(OioModal), {
      visible: visible.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
      title: "批量绑定导航",
      width: 760,
      maskClosable: false,
      onCancel: closeModal
    }, {
      footer: _withCtx(() => [
        _createVNode(_unref(OioButton), { onClick: closeModal }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        }),
        _createVNode(_unref(OioButton), {
          type: "primary",
          loading: confirmLoading.value,
          onClick: submitSelection
        }, {
          default: _withCtx(() => [
            _createTextVNode("确定绑定")
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            (treeData.value.length)
              ? (_openBlock(), _createBlock(_component_a_tree, {
                  key: 0,
                  checkable: "",
                  "block-node": "",
                  "default-expand-all": "",
                  "tree-data": treeData.value,
                  checkedKeys: checkedKeys.value,
                  onCheck: handleCheck
                }, {
                  title: _withCtx(({ title, code, count }) => [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("span", null, _toDisplayString(title) + "（" + _toDisplayString(code) + "）", 1),
                      (typeof count === 'number')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_6, "（" + _toDisplayString(count) + "）", 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                }, 8, ["tree-data", "checkedKeys"]))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, "当前页面未配置导航栏"))
          ])
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})